import { GerasApi } from "../sdk"
import { AuthHttpRequest } from "../sdk/AuthHttpRequest"

export const apiV2 = new GerasApi({
  BASE: process.env.REACT_APP_NEW_API_URL,
  TOKEN: () => Promise.resolve(window.localStorage.getItem('token') ?? ''),
}, AuthHttpRequest)

export type ApiV2Response<T> = { success: false, error: string } | {
  success: true,
  data: T,
}

export function wrapResponse<T>(request: Promise<T>): Promise<ApiV2Response<T>> {
  return request
    .then(data => ({data, success: true} as const))
    .catch(error => ({error: error?.body?.message ?? 'Unknown error', success: false} as const))
}

export type SdkResponse<T extends (...args: any) => any> = ApiV2Response<Awaited<ReturnType<T>>>
